import React from 'react';
import Scrollspy from 'react-scrollspy';


const SideNav = props => {

    /**
    * scrollToTag method is used to scroll to particular div.
    * it takes id and using that it finds offsetTop
    * @param {*} id  contains the id to what div needs to be in view
    */
    const scrollToTag = (id) => {
        const element = document.getElementById(id);
        if (element) {
            const offset = element.offsetTop;
            window.scrollTo({ behavior: 'smooth', top: offset });
        }
    };
    return (
        <>
            <Scrollspy
                className="scrollspy" items={ props.sectionIDs }
                offset={ -200 }
                currentClassName="isCurrent">
                {
                    props.sections && !!props.sections.length && props.sections.map((obj, index) => {
                        return <li key={ obj.id }><a href={ `#${obj.id}` } onClick={ (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            scrollToTag(obj.id);
                        } }>{ obj.title }</a></li>;
                    })
                }
            </Scrollspy>
        </>
    );
};

export default SideNav;